import { fetchFlask } from '../../utils/fetchFlask';
import { maskCEP, maskCpfCnpj, maskPhone } from '../../utils/maskCpfCnpj';
import { CNPJ_DIGITS_LENGTH, getDigits, normalizeText } from '../../utils/stringFormat';

const CREATE_DOCUMENTS_API = 'createDocuments';
const CEP_API = 'buscarDadosCEP';
const CNPJ_CARD_API = 'getCnpjData';
const LEAD_UNITS_API = 'crm/leadsUnits';
const DEFAULT_DISCOUNT = 20;
const CPF_DIGITS_LENGTH = 11;

export const CIDADES_PE = [
    'Abreu e Lima', 'Afogados da Ingazeira', 'Afrânio', 'Agrestina',
    'Água Preta', 'Águas Belas', 'Alagoinha', 'Aliança', 'Altinho',
    'Amaraji', 'Angelim', 'Araçoiaba', 'Araripina', 'Arcoverde',
    'Barra de Guabiraba', 'Barreiros', 'Belém de Maria', 'Belém de São Francisco',
    'Belo Jardim', 'Betânia', 'Bezerros', 'Bodocó', 'Bom Conselho',
    'Bom Jardim', 'Bonito', 'Brejão', 'Brejinho', 'Brejo da Madre de Deus',
    'Buenos Aires', 'Buíque', 'Cabo de Santo Agostinho', 'Cabrobó',
    'Cachoeirinha', 'Caetés', 'Calçado', 'Calumbi', 'Camaragibe',
    'Camocim de São Félix', 'Camutanga', 'Canhotinho', 'Capoeiras',
    'Carnaíba', 'Carnaubeira da Penha', 'Carpina', 'Caruaru',
    'Casinhas', 'Catende', 'Cedro', 'Chã de Alegria', 'Chã Grande',
    'Condado', 'Correntes', 'Cortês', 'Cumaru', 'Cupira',
    'Custódia', 'Dormentes', 'Escada', 'Exu', 'Feira Nova',
    'Fernando de Noronha', 'Ferreiros', 'Flores', 'Floresta',
    'Frei Miguelinho', 'Gameleira', 'Garanhuns', 'Glória do Goitá',
    'Goiana', 'Granito', 'Gravatá', 'Iati', 'Ibimirim',
    'Ibirajuba', 'Igarassu', 'Iguaracy', 'Ilha de Itamaracá',
    'Inajá', 'Ingazeira', 'Ipojuca', 'Ipubi', 'Itacuruba',
    'Itaíba', 'Itambé', 'Itapetim', 'Itapissuma', 'Itaquitinga',
    'Jaboatão dos Guararapes', 'Jaqueira', 'Jataúba', 'Jatobá',
    'João Alfredo', 'Joaquim Nabuco', 'Jucati', 'Jupi',
    'Jurema', 'Lagoa de Itaenga', 'Lagoa do Carro', 'Lagoa do Ouro',
    'Lagoa dos Gatos', 'Lagoa Grande', 'Lajedo', 'Limoeiro',
    'Macaparana', 'Machados', 'Manari', 'Maraial', 'Mirandiba',
    'Moreilândia', 'Moreno', 'Nazaré da Mata', 'Olinda',
    'Orobó', 'Orocó', 'Ouricuri', 'Palmares', 'Palmeirina',
    'Panelas', 'Paranatama', 'Parnamirim', 'Passira', 'Paudalho',
    'Paulista', 'Pedra', 'Pesqueira', 'Petrolândia', 'Petrolina',
    'Poção', 'Pombos', 'Primavera', 'Quipapá', 'Quixaba',
    'Recife', 'Riacho das Almas', 'Ribeirão', 'Rio Formoso',
    'Sairé', 'Salgadinho', 'Salgueiro', 'Saloá', 'Sanharó',
    'Santa Cruz', 'Santa Cruz da Baixa Verde', 'Santa Cruz do Capibaribe',
    'Santa Filomena', 'Santa Maria da Boa Vista', 'Santa Maria do Cambucá',
    'Santa Terezinha', 'São Benedito do Sul', 'São Bento do Una',
    'São Caitano', 'São João', 'São Joaquim do Monte', 'São José da Coroa Grande',
    'São José do Belmonte', 'São José do Egito', 'São Lourenço da Mata',
    'São Vicente Férrer', 'Serra Talhada', 'Serrita', 'Sertânia',
    'Sirinhaém', 'Solidão', 'Surubim', 'Tabira', 'Tacaimbó',
    'Tacaratu', 'Tamandaré', 'Taquaritinga do Norte', 'Terezinha',
    'Terra Nova', 'Timbaúba', 'Toritama', 'Tracunhaém',
    'Trindade', 'Triunfo', 'Tupanatinga', 'Tuparetama',
    'Venturosa', 'Verdejante', 'Vertente do Lério', 'Vertentes',
    'Vicência', 'Vitória de Santo Antão', 'Xexéu'
];

export const CIDADES_RN = [
    'Acari', 'Açu', 'Afonso Bezerra', 'Água Nova', 'Alexandria',
    'Almino Afonso', 'Alto do Rodrigues', 'Angicos', 'Antônio Martins',
    'Apodi', 'Areia Branca', 'Arês', 'Augusto Severo',
    'Baía Formosa', 'Baraúna', 'Barcelona', 'Bento Fernandes',
    'Bodó', 'Bom Jesus', 'Brejinho', 'Caiçara do Norte',
    'Caiçara do Rio do Vento', 'Caicó', 'Campo Redondo',
    'Canguaretama', 'Caraúbas', 'Carnaúba dos Dantas',
    'Carnaubais', 'Ceará-Mirim', 'Cerro Corá',
    'Coronel Ezequiel', 'Coronel João Pessoa',
    'Cruzeta', 'Currais Novos', 'Doutor Severiano',
    'Encanto', 'Equador', 'Espírito Santo',
    'Extremoz', 'Felipe Guerra', 'Fernando Pedroza',
    'Florânia', 'Francisco Dantas', 'Frutuoso Gomes',
    'Galinhos', 'Goianinha', 'Governador Dix-Sept Rosado',
    'Grossos', 'Guamaré', 'Ielmo Marinho',
    'Ipanguaçu', 'Ipueira', 'Itajá', 'Itaú',
    'Jaçanã', 'Jandaíra', 'Janduís', 'Januário Cicco',
    'Japi', 'Jardim de Angicos', 'Jardim de Piranhas',
    'Jardim do Seridó', 'João Câmara', 'João Dias',
    'José da Penha', 'Jucurutu', 'Jundiá',
    'Lagoa d\'Anta', 'Lagoa de Pedras', 'Lagoa de Velhos',
    'Lagoa Nova', 'Lagoa Salgada', 'Lajes',
    'Lajes Pintadas', 'Lucrécia', 'Luís Gomes',
    'Macaíba', 'Macau', 'Major Sales',
    'Marcelino Vieira', 'Martins', 'Maxaranguape',
    'Messias Targino', 'Montanhas', 'Monte Alegre',
    'Monte das Gameleiras', 'Mossoró', 'Natal',
    'Nísia Floresta', 'Nova Cruz', 'Olho d\'Água do Borges',
    'Ouro Branco', 'Paraná', 'Paraú',
    'Parazinho', 'Parelhas', 'Parnamirim',
    'Passa e Fica', 'Passagem', 'Patu',
    'Pau dos Ferros', 'Pedra Grande', 'Pedra Preta',
    'Pedro Avelino', 'Pedro Velho', 'Pendências',
    'Pilões', 'Poço Branco', 'Portalegre',
    'Porto do Mangue', 'Presidente Juscelino',
    'Pureza', 'Rafael Fernandes', 'Rafael Godeiro',
    'Riacho da Cruz', 'Riacho de Santana',
    'Riachuelo', 'Rio do Fogo', 'Rodolfo Fernandes',
    'Ruy Barbosa', 'Santa Cruz', 'Santa Maria',
    'Santana do Matos', 'Santana do Seridó',
    'Santo Antônio', 'São Bento do Norte',
    'São Bento do Trairi', 'São Fernando',
    'São Francisco do Oeste', 'São Gonçalo do Amarante',
    'São João do Sabugi', 'São José de Mipibu',
    'São José do Campestre', 'São José do Seridó',
    'São Miguel', 'São Miguel do Gostoso',
    'São Paulo do Potengi', 'São Pedro',
    'São Rafael', 'São Tomé',
    'São Vicente', 'Senador Elói de Souza',
    'Senador Georgino Avelino', 'Serra de São Bento',
    'Serra do Mel', 'Serra Negra do Norte',
    'Serrinha', 'Serrinha dos Pintos',
    'Severiano Melo', 'Sítio Novo',
    'Taboleiro Grande', 'Taipu',
    'Tangará', 'Tenente Ananias',
    'Tenente Laurentino Cruz', 'Tibau',
    'Tibau do Sul', 'Timbaúba dos Batistas',
    'Touros', 'Triunfo Potiguar',
    'Umarizal', 'Upanema',
    'Várzea', 'Venha-Ver',
    'Vera Cruz', 'Viçosa',
    'Vila Flor'
];

export const ESTADOS_ATENDIDOS = ['PE', 'RN'];

export const ESTADOS_BRASIL = [
    ...ESTADOS_ATENDIDOS,
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA',
    'PB', 'PR', 'PI', 'RJ', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];

export const CIDADES_POR_ESTADO = {
    PE: CIDADES_PE,
    RN: CIDADES_RN
};

const ESTADO_POR_NOME = {
    pernambuco: 'PE',
    'rio grande do norte': 'RN'
};

export const MARITAL_STATUS_OPTIONS = ['Casado', 'Solteiro', 'União Estável', 'Divorciado', 'Viúvo'];

export const CLASSIFICATION_OPTIONS = [
    { value: 'bt', label: 'Baixa Tensão' },
    { value: 'at', label: 'Alta Tensão' },
    { value: 'bto', label: 'Baixa Tensão Optante' }
];

export const VERIFICATION_OPTIONS = [
    { value: 'SMS', label: 'SMS' },
    { value: 'EMAIL', label: 'E-mail' }
];

export const CONTRACT_STEPS = [
    { key: 'cliente', label: 'Cliente' },
    { key: 'unidades', label: 'Unidades e condições' },
    { key: 'envio', label: 'Envio' }
];

export const EMPTY_ADDRESS = {
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    cep: ''
};

export const EMPTY_REPRESENTATIVE = {
    name: '',
    cpf: '',
    address: '',
    cep: ''
};

const toText = (value) => (value === null || value === undefined ? '' : String(value));

export const getLeadClientType = (document) => (
    getDigits(document).length === CNPJ_DIGITS_LENGTH ? 'pj' : 'pf'
);

export const getLeadDiscountPercent = (desconto) => (
    desconto === null || desconto === undefined || desconto === ''
        ? DEFAULT_DISCOUNT
        : Math.round(Number(desconto) * 100)
);

export const getLeadCoupon = (cupom) => {
    const coupon = toText(cupom).trim();
    return coupon === 'Sem Cupom' ? '' : coupon;
};

export const getFirstName = (name) => toText(name).trim().split(/\s+/)[0] ?? '';

export const getDistribuidoraFromState = (state) => {
    if (state === 'RN') return 'COSERN';
    if (state === 'PE') return 'NEOENERGIA PE';
    return '';
};

export const formatUnitAddress = (address) => {
    if (!address) return '';

    return [
        address.rua,
        address.numero,
        address.complemento,
        address.bairro,
        address.cidade,
        address.estado,
        address.cep
    ].filter(Boolean).join(' ');
};

export const getUnitKey = (unit, index) => toText(unit.unidade_id ?? `${unit.codigo_do_cliente ?? ''}-${index}`);

export const mapUnitToContractUnit = (unit) => ({
    cc: toText(unit.codigo_do_cliente ?? unit.cc),
    address: formatUnitAddress(unit.endereco),
    consumption: toText(unit.consumo_medio ?? unit.consumption),
    state: getDistribuidoraFromState(unit.endereco?.estado)
});

export const getClassificationFromUnits = (units) => (
    units.some((unit) => Boolean(unit.alta_tensao)) ? 'at' : 'bt'
);

export const matchCityOption = (state, city) => {
    const options = CIDADES_POR_ESTADO[state] ?? [];
    const normalizedCity = normalizeText(city).trim();
    if (!normalizedCity) return '';
    return options.find((option) => normalizeText(option) === normalizedCity) ?? toText(city).trim();
};

const getServedState = (state) => {
    const uf = toText(state).trim().toUpperCase();
    return ESTADOS_ATENDIDOS.includes(uf) ? uf : '';
};

export const getAddressFromUnit = (unit) => {
    const endereco = unit?.endereco ?? {};
    const state = getServedState(endereco.estado);

    return {
        street: toText(endereco.rua),
        number: toText(endereco.numero),
        complement: toText(endereco.complemento),
        neighborhood: toText(endereco.bairro),
        city: matchCityOption(state, endereco.cidade),
        state,
        cep: maskCEP(toText(endereco.cep))
    };
};

export const isCpfComplete = (value) => getDigits(value).length === CPF_DIGITS_LENGTH;

export const isCnpjComplete = (value) => getDigits(value).length === CNPJ_DIGITS_LENGTH;

export const isFilled = (value) => toText(value).trim() !== '';

export const getMissingAddressFields = (address) => [
    !isFilled(address.cep) && 'CEP',
    !isFilled(address.street) && 'rua',
    !isFilled(address.number) && 'número',
    !isFilled(address.neighborhood) && 'bairro',
    !isFilled(address.city) && 'cidade',
    !isFilled(address.state) && 'estado'
].filter(Boolean);

export const getMissingRepresentativeFields = (representative) => [
    !isFilled(representative.name) && 'nome do representante',
    !isCpfComplete(representative.cpf) && 'CPF do representante',
    !isFilled(representative.address) && 'endereço do representante',
    !isFilled(representative.cep) && 'CEP do representante'
].filter(Boolean);

export const joinLabels = (labels) => {
    if (labels.length <= 1) return labels.join('');
    return `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}`;
};

export const fetchLeadUnits = async (leadId) => {
    const response = await fetchFlask(LEAD_UNITS_API, JSON.stringify({ lead_id: leadId }));
    if (response?.status !== 'success') {
        throw new Error(response?.message || 'Não foi possível carregar as unidades do lead.');
    }
    return Array.isArray(response.data) ? response.data : [];
};

export const fetchAddressByCep = async (cep) => {
    const response = await fetchFlask(CEP_API, JSON.stringify({ cep }));
    if (response?.status !== 'success') return { error: response };

    const data = response.data ?? {};
    const state = ESTADO_POR_NOME[normalizeText(data.estado)] ?? '';

    return {
        address: {
            street: toText(data.logradouro),
            neighborhood: toText(data.bairro),
            city: matchCityOption(state, data.localidade),
            state
        }
    };
};

export const fetchCnpjCardData = async (file) => {
    const formData = new FormData();
    formData.append('cnpj', file);

    const response = await fetchFlask(CNPJ_CARD_API, formData);
    if (response?.status !== 'success') return { error: response };

    return {
        name: toText(response.name),
        cnpj: maskCpfCnpj(toText(response.cnpj)),
        address: {
            street: toText(response.street),
            number: toText(response.number),
            complement: toText(response.complement),
            neighborhood: toText(response.neighborhood),
            city: toText(response.city),
            cep: toText(response.cep)
        }
    };
};

export const buildContractFormData = ({
    leadData,
    clientType,
    clientName,
    address,
    maritalStatus,
    representative,
    classification,
    verificationType,
    contactName,
    phone2,
    units,
    notificarCliente,
    files
}) => {
    const formData = new FormData();

    if (files.cnh) formData.append('cnh', files.cnh);
    if (files.contrato) formData.append('contrato', files.contrato);
    if (files.cnpj) formData.append('cnpj', files.cnpj);
    if (address.complement) formData.append('complement', address.complement);

    formData.append('representativeAddress', [representative.address, representative.cep].filter(Boolean).join(', '));
    formData.append('clientType', clientType);
    formData.append('clientName', clientName);
    formData.append('cpfCnpj', maskCpfCnpj(toText(leadData.cpf)));
    formData.append('street', address.street);
    formData.append('addressNumber', address.number);
    formData.append('neighborhood', address.neighborhood);
    formData.append('city', address.city);
    formData.append('cep', address.cep);
    formData.append('state', address.state);
    formData.append('maritalStatus', maritalStatus);
    formData.append('representativeName', representative.name);
    formData.append('representativeCpf', representative.cpf);
    formData.append('discount', getLeadDiscountPercent(leadData.desconto));
    formData.append('classification', classification);
    formData.append('verificationType', verificationType);
    formData.append('contactName', contactName);
    formData.append('email', toText(leadData.email));
    formData.append('phone1', maskPhone(toText(leadData.telefone)));
    formData.append('phone2', toText(phone2));
    formData.append('units', JSON.stringify(units.map(mapUnitToContractUnit)));
    formData.append('notificarCliente', notificarCliente);
    formData.append('coupon', getLeadCoupon(leadData.cupom));
    formData.append('lead_id', String(leadData.lead_id));

    return formData;
};

export const submitContract = (formData) => fetchFlask(CREATE_DOCUMENTS_API, formData);
